import { html } from 'lit';

export const iconPencil = html`
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.65625 5.55469L9.11719 6.09375L4.45312 10.7578C4.21875 11.0156 3.91406 11.1797 3.58594 11.2969L0.75 12.1172C0.5625 12.1641 0.351562 12.1172 0.210938 11.9766C0.046875 11.8359 0 11.625 0.0703125 11.4141L0.890625 8.60156C0.984375 8.27344 1.17188 7.96875 1.40625 7.71094L6.07031 3.04688L6.60938 2.53125L6.86719 2.25L7.66406 3.04688L9.11719 4.5L9.91406 5.29688L9.65625 5.55469ZM3.79688 9.51562H3.04688C2.83594 9.51562 2.67188 9.35156 2.67188 9.14062V8.39062L2.13281 8.60156C2.0625 8.69531 1.99219 8.78906 1.96875 8.90625L1.42969 10.7344L3.25781 10.1953C3.375 10.1719 3.46875 10.125 3.5625 10.0547L3.79688 9.51562ZM8.53125 0.585938C9.11719 0 10.0781 0 10.6641 0.585938L11.5781 1.52344C12.1641 2.10938 12.1641 3.04688 11.5781 3.63281L11.25 3.98438L10.7109 4.5L10.4531 4.75781L9.65625 3.98438L8.20312 2.50781L7.40625 1.73438L7.66406 1.45312L8.20312 0.9375L8.53125 0.585938ZM7.42969 4.52344C7.57031 4.38281 7.57031 4.14844 7.42969 4.00781C7.28906 3.84375 7.03125 3.84375 6.89062 4.00781L3.51562 7.38281C3.375 7.52344 3.375 7.75781 3.51562 7.89844C3.65625 8.03906 3.91406 8.03906 4.05469 7.89844L7.42969 4.52344Z"
    />
  </svg>
`;
